import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { configureLogging, createLogger } from '@pridehub/shared/util';
import { environment } from '@pridehub/shared/environments';

configureLogging(environment.logLevel, 'Pridehub.ExternalWebsite');
const bootstrapLogger = createLogger('Bootstrap');

bootstrapApplication(App, appConfig)
  .catch((err) => bootstrapLogger.error('Bootstrap failed', err));
